// extracted by mini-css-extract-plugin
module.exports = {"countdown":"mg","srOnly":"ng"};